import { Toaster as Sonner } from "sonner" // Only import Toaster from sonner
import { useTheme } from "@/context/ThemeContext" // Import useTheme

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme() // Use the theme context

  return (
    <Sonner
      theme={resolvedTheme === 'dark' ? 'dark' : 'light'}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toaster]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toaster]:text-muted-foreground",
          success:
            "group-[.toaster]:text-green-500 dark:group-[.toaster]:text-green-400",
          error:
            "group-[.toaster]:text-red-500 dark:group-[.toaster]:text-red-400",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
